(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["video-banner"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const videos = document.querySelectorAll('.video-banner-head video');
  videos.forEach(video => {
    video.load();
    video.play().catch(error => {
      console.log('Video autoplay failed:', error);
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-banner2"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const videos = document.querySelectorAll('.video-banner-head video');
  videos.forEach(video => {
    video.load();
    video.play().catch(error => {
      console.log('Video autoplay failed:', error);
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
